// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDYWWBKLtuMWRv5WKZf4BBPbvT4-THZg7s",
    authDomain: "studyflowv1.firebaseapp.com",
    databaseURL: "https://studyflowv1-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "studyflowv1",
    storageBucket: "studyflowv1.appspot.com",
    messagingSenderId: "729948932333",
    appId: "1:729948932333:web:b98f3e423df23ed53f24e4",
    measurementId: "G-CT5B1HVFH1"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
